import { render } from "./IconEditing.vue?vue&type=template&id=2a19dae4"
import script from "./IconEditing.vue?vue&type=script&lang=js"
export * from "./IconEditing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__